<div class="swiper #swiper w-full">
	<div class="swiper-wrapper">
	  @for (item of swiperItems; track item; let i = $index) {
	  <div class="swiper-slide w-fit">
		<div
		  class="w-fit flex flex-col items-center h-full gap-5"
		>
		  <div class="w-[204px] h-full content-end">
			<img
			  class="w-[204px] h-56"
			  [src]="item.img"
			  loading="lazy"
			/>
			<div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
		  </div>
		  <div class="pt-1">
			<div class="w-[204px]">
			  <h4 class="text-black rfs:text-xl">
				{{ item.title}}
			  </h4>
			  <p class="text-gray-700">
				{{ item.description}}
			  </p>
			</div>
		  </div>
		</div>
	  </div>
	  }
	</div>
</div>
<div class="flex flex-row justify-start items-start gap-4 mt-6">
	<button class="btn-icon-secondary custom-swiper-button-prev" (click)="navigatePrev()">
		<i class="icon-chevron-left"></i>
	</button>

	<button class="btn-icon-secondary custom-swiper-button-next" (click)="navigateNext()">
		<i class="icon-chevron-right"></i>
	</button>
</div>